<template>
  <div class="auth-page ">
    <div class="auth-main" v-if="isEditable">

      <div class="steps flex">
        <div class="step active line flex">
          <div class="icon flex-center " v-if="step == 1">1</div>
          <div class="icon" v-else>
            <img :src="successUrl" alt="">
          </div>
          <div class="info">
            <div class="label active">{{ $t('di-1-bu') }}</div>
            <div class="desc">{{ $t('tian-xie-ji-ben-xin-xi') }}</div>
          </div>
        </div>
        <div class="step  flex" :class="step == 2 ? 'active' : ''">
          <div class="icon flex-center" >2</div>
          <div class="info">
            <div class="label" >{{ $t('di-2-bu') }}</div>
            <div class="desc">{{ $t('userAuth.label4') }}</div>
          </div>
        </div>
      </div>

      <div class="warning-box flex" v-show="step == 1">
        <img :src="warningUrl" alt="">
        <span>{{ $t('wei-le-bao-zhang-zhang-hu-zi-jin-an-quan-xu-shi-ming-ren-zheng-hou-cai-neng-jin-hang-xiang-guan-cao-zuo-qing-nin-que-bao-suo-ti-jiao-de-xin-xi-zhen-shi-you-xiao') }}</span>
      </div>

      <div class="page-form">
        <div class="form-item" v-show="step == 1">
          <div class="label">{{ $t('userAuth.label1') }}</div>
          <div class="input">
            <a-select v-model="form.country"  dropdownClassName="full-select" class="hide-border">
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
              <a-select-opt-group  v-for="(item, i) in countryList" :key="i">
                <span slot="label">{{item.title}}</span>
                <a-select-option v-for="(child, index) in item.children" :key="index" :value="child.key" :label="child.key">
                  {{child.title}}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </div>
        </div>

        <div class="form-item" v-show="step == 1">
          <div class="label">{{ $t('resetPassword.label3') }}</div>
          <div class="input">
            <a-select v-model="form.cardType"  dropdownClassName="full-select" class="hide-border" :placeholder="$t('qing-xuan-ze-zheng-jian-lei-xing')">
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
              <a-select-option v-for="(option, index) in typeList" :key="index" :value="option.value" >
                {{option.text}}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="form-item" v-show="step == 1">
          <div class="label">{{ $t('xing-ming') }}</div>
          <div class="input">
            <input type="text" :placeholder="$t('qing-shu-ru-xing-ming')" v-model="form.username">
          </div>
        </div>

        <div class="form-item" v-show="step == 1">
          <div class="label">{{ $t('resetPassword.label4') }}</div>
          <div class="input">
            <input type="text" :placeholder="$t('qing-shu-ru-zheng-jian-hao-ma')" v-model="form.cardNo">
          </div>
        </div>

        <div class="file-box" v-show="step == 2">
          <div class="auth flex-column-center">
            <span class="desc">{{form.cardType == 1 ? $t('userAuth.label5') : $t('userAuth.label6')}}</span>
            <img :src="localImages[1] || (form.card1 ? `/upload/tmp/${form.card1}` : (form.cardType == 1 ? cardUrl1 : cardUrl3))" alt="" @click.stop="chooseFile(1)">
            <Progress v-if="showProgress[1]" :percentage="uploadPercent[1]" stroke-width="8" style="width: 80%; margin-top: 10px;" />
            <input type="file" class="hide-box" id="fileInput1" @change="changeFile($event, 1)" accept="image/*">
          </div>
          <div class="auth flex-column-center" v-show="form.cardType == 1">
            <span class="desc">{{ $t('userAuth.label7') }}</span>
            <img :src="localImages[2] || (form.card2 ? `/upload/tmp/${form.card2}` : cardUrl2)" alt="" @click.stop="chooseFile(2)">
            <Progress v-if="showProgress[2]" :percentage="uploadPercent[2]" stroke-width="8" style="width: 80%; margin-top: 10px;" />
            <input type="file" class="hide-box" id="fileInput2" @change="changeFile($event, 2)" accept="image/*">
          </div>
        </div>

        <div class="desc-box" v-show="step == 2">
          <div class="label">{{ $t('userAuth.desc1') }}</div>
          <div class="desc">{{ $t('1-zhi-chi-yu-5m-de-jpgjpeg-huo-png-ge-shi-tu-pian') }}</div>
          <div class="desc">{{ $t('2-zheng-jian-zhao-yao-qiu-qing-xi-bi-xu-kan-qing-ren-xiang-zheng-jian-hao-he-xing-ming') }}</div>
        </div>

        <div class="btn flex">
          <Button @click="prev"  v-if="step == 2">{{ $t('shang-yi-bu') }}</Button>
          <Button @click="submit" :class="btnDisabled ? 'gray' : ''">{{ $t('userAuth.btn1') }}</Button>
        </div>
      </div>
    </div>

    <div v-if="isSuccess" class="success-auth flex-column-center">
      <img :src="successUrl2" alt="">
      <span class="title">{{ $t('shen-fen-ren-zheng-cheng-gong') }}</span>
      <span class="desc">{{ $t('nin-yi-wan-cheng-shen-fen-ren-zheng-kai-shi-nin-de-jiao-yi') }}</span>
    </div>

    <div v-if="isPending" class="success-auth flex-column-center">
      <img :src="successUrl2" alt="">
      <span class="title">{{ $t('userAuth.status2') }}</span>
      <span class="desc">{{ $t('userAuth.statusDesc2') }}</span>
    </div>


  </div>
</template>
<script>
import { checkAuth, uploadFile, userIdentity } from '@/api/setting'
import { Button, Popup, Icon, Picker, Progress } from 'vant'
import heic2any from 'heic2any'
export default {
  components: {
    Button,
    Popup,
    Icon,
    Picker,
    Progress
  },
  data() {
    return {
      form: {
        username: '',
        cardNo: '',
        country: '+1',
        card1: '',
        card2: '',
        cardType: undefined,
      },
      typeList: [
        {
          value: '1',
          text: this.$t('shen-fen-zheng')
        },
        {
          value: '2',
          text: this.$t('hu-zhao')
        },
        {
          value: '3',
          text: this.$t('jia-shi-zheng')
        },
      ],
      step: 1,
      keyword: '',
      successUrl: require('../../assets/imgs/icon-success.png'),
      successUrl2: require('../../assets/imgs/icon-success2.png'),
      warningUrl: require('../../assets/imgs/icon-warning.png'),
      downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
      cardUrl1: require('../../assets/imgs/card-front.png'),
      cardUrl2: require('../../assets/imgs/card-back.png'),
      cardUrl3: require('../../assets/imgs/card-hz.png'),
      showPopup: false,
      showPicker: false,
      fileType: '',
      countryList: [],
      authStatus: '',
      uploadPercent: { 1: 0, 2: 0 },
      showProgress: { 1: false, 2: false },
      uploading: { 1: false, 2: false },
      localImages: { 1: '', 2: '' }
    }
  },
  computed: {
    countryListBak() {
      return this.$store.state.countryList
    },
    isEditable() {
      return String(this.authStatus) === '0'
    },
    isPending() {
      return String(this.authStatus) === '1'
    },
    isSuccess() {
      return String(this.authStatus) === '2'
    },
    btnDisabled() {
      if (this.step == 1) {
        return !this.form.country || !this.form.cardType || !this.form.cardNo || !this.form.username
      } else if (this.step == 2) {
        if (this.cardType == 1) {
          return !this.form.card1 || !this.form.card2
        } else {
          return !this.form.card1
        }
      }
    }
  },
  mounted() {
    this.countryList = [].concat(this.countryListBak)
    this.init()
  },
  methods: {
    init() {
      checkAuth().then(res => {
        this.authStatus = res.data.status
        if (!this.isEditable) {
          this.step = 1
          this.showPopup = false
          this.showPicker = false
        }
      })
    },
    back() {
      this.$router.go(-1)
    },
    showCountry() {
      this.showPopup = true
    },
    changeType() {
      this.showPicker = true
    },
    cancel() {
      this.showPopup = false
      this.showPicker = false
    },
    chooseType(item) {
      if (!this.isEditable) {
        return
      }
      this.form.cardType = item.value
      this.form.cardTypeName = item.text
      this.showPicker = false
    },
    chooseFile(type) {
      if (!this.isEditable) {
        return
      }
      if (this.uploading[type]) {
        this.$toast.fail(this.i18n.t('common.uploading'))
        return
      }
      const inputId = `fileInput${type}`
      document.getElementById(inputId).value = ''
      document.getElementById(inputId).click()
    },
    async changeFile(e, type) {
      if (!this.isEditable) return
      let file = e.target.files[0]
      if (!file) return
      
      // 确保 fileType 正确
      this.fileType = type

      if (file.name.toLowerCase().endsWith('.avif')) {
        this.$toast.fail(this.i18n.t('userAuth.imageFormatNotSupported', ['AVIF']))
        return
      }

      if (file.name.toLowerCase().endsWith('.dng')) {
        this.$toast.fail(this.i18n.t('userAuth.dngFormatNotSupported'))
        return
      }

      if (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
        try {
          this.$toast.loading({
            message: 'Processing...',
            forbidClick: true,
            duration: 0
          })
          const blob = await heic2any({
            blob: file,
            toType: 'image/jpeg',
            quality: 0.8
          })
          const convertedBlob = Array.isArray(blob) ? blob[0] : blob
          file = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg'), {
            type: 'image/jpeg'
          })
          this.$toast.clear()
        } catch (error) {
          this.$toast.clear()
          console.error('HEIC conversion failed', error)
          this.$toast.fail(this.i18n.t('userAuth.imageFormatNotSupported', ['HEIC']))
          return
        }
      }

      // Local preview
      this.localImages[type] = URL.createObjectURL(file)

      let form = new FormData()
      form.append('file', file)

      this.$set(this.showProgress, type, true)
      this.$set(this.uploadPercent, type, 0)
      this.$set(this.uploading, type, true)

      uploadFile(form, (progressEvent) => {
        this.$set(this.uploadPercent, type, Math.round((progressEvent.loaded * 100) / progressEvent.total))
      }).then(res => {
        this.$set(this.showProgress, type, false)
        this.$set(this.uploading, type, false)
        if (res.code == 0) {
          this.$toast.success(this.i18n.t('userAuth.success1'))
          this.form[`card${type}`] = res.data
        } else {
          this.$toast.fail(res.msg)
          // Clear local preview on error
          this.localImages[type] = ''
        }
      }).catch(() => {
        this.$set(this.showProgress, type, false)
        this.$set(this.uploading, type, false)
        this.localImages[type] = ''
      })
    },
    prev() {
      this.step = 1
    },
    submit() {
      if (!this.isEditable) {
        return
      }
      if (this.uploading[1] || this.uploading[2]) {
        this.$toast.fail(this.i18n.t('common.uploading'))
        return
      }
      if (this.btnDisabled) {
        return
      }
      if (this.step == 1) {
        this.step = 2
      } else if (this.step == 2) {
        let form = new FormData()
        form.append('RealName', this.form.username)
        form.append('Country', this.form.country)
        form.append('CardNo', this.form.cardNo)
        form.append('CardFront', this.form.card1)
        form.append('CardBack', this.form.card2)
        form.append('CardType', this.form.cardType)
        userIdentity(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('userAuth.success2'))
            this.authStatus = 1
            this.step = 1
            this.showPopup = false
            this.showPicker = false
          } else {
            this.$toast.fail(res.msg)
          }
        })
      }

    },
  }
}
</script>
